<div>
    <!-- Input file oculto -->
    <input type="file" [attr.id]="'file-input-'+id" (change)="loadFiles($event)" multiple hidden>

    <!-- Botón personalizado -->
    <button class="btn-select-files" (click)="triggerFileInput()" i18n="@@selectFileButton" i18n>Seleccionar archivo</button>

    <!-- Texto para mostrar el nombre del archivo -->
    <span class="span-select-files" i18n *ngIf="!selectedFileName">Ningun archivo seleccionado</span>
    <span class="span-select-files" *ngIf="selectedFileName">{{selectedFileName}}</span>
</div>